export default (state = '', action) => {
    switch (action.type) {
        case 'UPDATE_SEARCH_KEY':
            return action.payload;
        case 'RESET_SEARCH_KEY':
            return ''
        default:
            return state;
    }
};